import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ClipboardPencilOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ClipboardPencilOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M22.91 5.75a3.18 3.18 0 0 0-2.25-.93c-.81 0-1.63.31-2.25.93l-.25.25V2.5h-4v-2h-10v2h-4v16c0 2.76 2.24 5 5 5h8c2.76 0 5-2.24 5-5V15l4.75-4.75a3.187 3.187 0 0 0 0-4.5ZM6.16 2.5h6V3c0 1.65-1.35 3-3 3s-3-1.35-3-3v-.5Zm10 16c0 1.65-1.35 3-3 3h-8c-1.65 0-3-1.35-3-3v-14h2.25C5.05 6.52 6.92 8 9.16 8s4.11-1.48 4.75-3.5h2.25V8l-6.5 6.5V19h4.5l2-2v1.5Zm5.34-9.66L13.34 17h-1.67v-1.67l8.16-8.16c.22-.22.52-.35.84-.35.32 0 .61.12.84.35.22.22.35.52.35.84 0 .32-.12.61-.35.84l-.01-.01Z" fill="currentColor" />
    </svg>;
}) as ForwardedIconComponent);
export default ClipboardPencilOutlined;